module.exports = __webpack_public_path__ + "img/pageinteriors_04asesoria-en-siniestros-03.95870462.jpg";